import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "react-redux";
import { bedActions } from "../../core/actions";
import { patientActions } from "../../core/actions";
import { doctorActions } from "../../core/actions";
import Select, { createFilter } from "react-select";
import {
  DISCHARGESUMMARY,
  VISIT_STATUS_OPEN,
  ROOM_STATUS_AVAILABLE,
  ROOM,
  DASHBOARD,
  VISIT_STATUS_CLOSED,
  PRODUCT_HMS_LOCATION,
} from "../../shared/constants";
import Button from "@mui/material/Button";
import { helperServices } from "../../shared/helper";
import CloseIcon from "@mui/icons-material/Close";
import { PATIENT_VISIT_INTERNAL_STATUS } from "../../core/constants/erpConstants";

function BtnCellRenderer(props) {
  // console.log("props in cellerenderer:", props);
  //console.log("displayProducts:displayProducts:",displayProducts);
  const [search, SetSearch] = useState();
  const [showModal, setShowModal] = useState(false);
  //const [assignRoomValue, setAssignRoomValue] = useState(Boolean);
  const [productId, setProductId] = useState();
  const [displayProducts, setDisplayProducts] = useState([]);
  const dispatch = useDispatch();
  const isWalkinVisit =
    (props.data?.visit?.visitflag || "").toLowerCase() === "walkin";
  const handleEditClick = (bedDetailList, event) => {
    console.log("data : ", bedDetailList);
    let instInfo = {};
    // instInfo['instId'] = instId
    // instInfo['userTopicid'] = userTopicid
    props.context.componentParent({ bedDetailList });
  };
  // let displayProducts =[];

  const handleFormEditClick = (id) => {
    console.log("edit:", id);
    props.context.componentParent({ id });
  };

  const patientVisitClick = (visitsList, event) => {
    console.log("data : ", visitsList);
    visitsList["typeFlag"] = "assignDoctor";
    props.context.componentParent({ visitsList });
  };

  const patientCloseClick = (visitsList, event) => {
    console.log("data : ", visitsList);
    visitsList["typeFlag"] = "patientClose";
    props.context.componentParent({ visitsList });
  };

  const patientOnboard = (visitsList, event) => {
    console.log("patientOnboard : ", visitsList);
    visitsList["typeFlag"] = "patientOnBoard";
    props.context.componentParent({ visitsList });
  };

  const patientInsurance = (visitsList, event) => {
    console.log("patientInsurance : ", visitsList);
    visitsList["typeFlag"] = "Insurance";
    props.context.componentParent({ visitsList });
  };

  const addComplaints = (visitsList, event) => {
    console.log("addComplaints : ", visitsList);
    visitsList["typeFlag"] = "Complaint";
    props.context.componentParent({ visitsList });
  };

  const attachFiles = (visitsList, event) => {
    console.log("attachFiles : ", visitsList);
    visitsList["typeFlag"] = "AttachFile";
    props.context.componentParent({ visitsList });
  };

  const moveToBill = (visitsList, event) => {
    console.log("movetobill : ", visitsList);
    visitsList["typeFlag"] = "MoveToBill";
    props.context.componentParent({ visitsList });
  };

  const viewProcedureList = (visitsList) => {
    visitsList["typeFlag"] = "ProcedureList";
    props.context.componentParent({ visitsList });
  };

  const allocateRoom = (visitsList, event) => {
    console.log("attachFiles : ", visitsList);
    visitsList["typeFlag"] = "AllocateRoom";
    props.context.componentParent({ visitsList });
  };

  const patientRevisitClick = (revisitsList, event) => {
    console.log("data : ", revisitsList);
    revisitsList["typeFlag"] = "bookvisit";
    props.context.componentParent({ revisitsList });
  };

  const patientfollowUp = (revisitsList, event) => {
    console.log("data : ", revisitsList);
    revisitsList["typeFlag"] = "appointment";
    props.context.componentParent({ revisitsList });
  };

  const patientRescheduleClick = (revisitsList, event) => {
    console.log("data : ", revisitsList);
    revisitsList["typeFlag"] = "reschedule";
    props.context.componentParent({ revisitsList });
  };

  const patientOutClick = (revisitsList, event) => {
    console.log("data : ", revisitsList);
    revisitsList["typeFlag"] = "cancel";
    props.context.componentParent({ revisitsList });
  };

  const dischargeSummaryClick = (visitsList) => {
    console.log("data : ", visitsList);
    visitsList["typeFlag"] = "dischargeSummary";
    props.context.componentParent({ visitsList });
  };

  const assignRoom = (value, data) => {
    // document.getElementById("roomassign").checked = value;
    data.checked = value;
    console.log("data,event assign room : ", value, data);
    data["assignedroom"] = value;
    //data.checked =  data["assignedroom"];
    props.context.componentParent({ data });
  };

  const updateProductId = (value, data) => {
    console.log("value, data :", value, data);
    console.log("productId :", productId);
    // data.productId = value;
    data["key"] = "action";
    props.context.componentParent({ data });
  };

  const getProducts = (value, data) => {
    SetSearch(value);
    console.log("prod value", value);
    data["key"] = "product";
    data.productName = value;
    //['productId'] = value;
    console.log("prod name", data);
    if (value.length > 2) {
      searchProduct(value);
    } else {
      setDisplayProducts(null);
      //props.data.value = value;
    }
  };

  const searchProduct = (value) => {
    let productsearch = value;
    let location = 0;
    console.log("searchedvalue", productsearch);
    dispatch(
      doctorActions.getProductDetails(
        productsearch,
        PRODUCT_HMS_LOCATION,
        (resCb) => {
          if (resCb && resCb.erpProductList) {
            console.log("Response of searched product", resCb.erpProductList);
            //  setDisplayProducts([...resCb.products]);
            setDisplayProducts([...resCb.erpProductList]);
          }
        }
      )
    );
  };

  const productSelected = (data) => {
    console.log("data in product", data);
    data.productName = data.productName;
    SetSearch(data.productName);
    setDisplayProducts(null);
    props.context.componentParent({ data });
  };

  const tpaDeleteClick = (event) => {
    let instInfo = {};

    props.context.componentParent({});
  };

  const pServiceDeleteClick = (event) => {
    console.log("event of service delete click", event);
  };

  const adminPageHeader = useSelector(
    (state) => state.patientDetailsState.pageheader
  );

  const handleChange = (event, data) => {
    // console.log("selectedOption",event.target.selectedOptions[0].getAttribute('id'));
    console.log("data:", data);
    // data.productId = event.target.selectedOptions[0].getAttribute('id');
    data["productName"] = event.target.value;
    data["key"] = "productId";
    setDisplayProducts([]);
    props.data.value = event.target.value;
    props.context.componentParent({ data });
  };

  return (
    <div className="d-flex align-items-center gap-2" style={{ height: "100%" }}>
      {window.location.href.split("/")[3] === "Bed" && (
        <>
          <i
            className="material-icons cpointer"
            title="Edit"
            onClick={(event) => handleEditClick(props.data, event)}
            style={{ color: "inherit" }}
          >
            edit
          </i>
          <i
            className="material-icons cpointer"
            title="Delete"
            onClick={(event) => {
              /* add delete logic if needed */
            }}
            style={{ color: "#a32424" }}
          >
            delete
          </i>
        </>
      )}

      {window.location.href.split("/")[3] === "Followup" && (
        <>
          <i
            className="material-icons cpointer"
            title="Onboard"
            onClick={(event) => patientRevisitClick(props.data, event)}
          >
            add
          </i>
          {/* Temporarily disabled: Follow-up appointment calendar action.
          <i
            className="material-icons cpointer"
            title="Appointment"
            onClick={(event) => patientfollowUp(props.data, event)}
          >
            calendar_month
          </i>
          */}
          <i
            className="material-icons cpointer"
            title="Update"
            onClick={(event) => patientRescheduleClick(props.data, event)}
          >
            update
          </i>
          <i
            className="material-icons cpointer"
            title="Delete"
            onClick={(event) => patientOutClick(props.data, event)}
            style={{ color: "#a32424" }}
          >
            delete
          </i>
        </>
      )}

      {adminPageHeader === "Admin" && props.data?.visit && (
        <>
          <i
            className="material-icons cpointer"
            title="View Procedures"
            aria-label="View Procedures"
            onClick={() => viewProcedureList(props.data)}
            style={{ color: "#176fad" }}
          >
            list_alt
          </i>

            {props.data.visit.status !== VISIT_STATUS_CLOSED &&
            props.data.visit.internalStatus !== "notInSite" &&
           props.data.visit.meetingStatus !== "completed" &&
            !props.data.doc &&
        (helperServices.CheckAccessLevel("patients") ||
         helperServices.CheckAccessLevel("FrontDeskPatients")) && ( 
              <i
                className="material-icons cpointer"
                title="Assign Doctor"
                onClick={(event) => patientVisitClick(props.data, event)}
                style={{ color: "#006fe6" }}
              >
                medical_services
              </i>
            )
          }

          {(props.data.visit.status === VISIT_STATUS_CLOSED ||
            props.data.visit.internalStatus === "notInSite") &&
            (helperServices.CheckAccessLevel("patients") ||
              helperServices.CheckAccessLevel("FrontDeskPatients") ||
              helperServices.CheckAccessLevel("InsurancePatients")) && (
              <i
                className="material-icons cpointer"
                title="Onboard"
                onClick={(event) => patientOnboard(props.data, event)}
              >
                add
              </i>
            )}

          {props.data.insurance === "YES" &&
            props.data.visit.type === "InPatient" &&
            helperServices.CheckAccessLevel("FrontDeskPatients") && (
              <i
                className="material-icons cpointer disable-btn"
                title="Insurance"
                onClick={(event) => patientInsurance(props.data, event)}
              >
                policy
              </i>
            )}

          {/* {props.data.visit.status !== "close" &&
          props.data.visit.internalStatus !== "notInSite" &&
          helperServices.CheckAccessLevel("patients") && (
            <i
              className="material-icons cpointer"
              title="Complaints"
              onClick={(event) => addComplaints(props.data, event)}
              style={{ color: "#176217" }}
            >
              note_add
            </i>
          )} */}

          {/* {props.data.visit.type === "InPatient" &&
          !isWalkinVisit &&
          helperServices.CheckAccessLevel("patients") && (
            <i
              className="material-icons cpointer disable-btn"
              title="Assign Room"
              onClick={(event) => allocateRoom(props.data, event)}
            >
              room_preferences
            </i>
          )} */}

          {(props.data.visit.type === "InPatient" ||
            (props.data.visit.type === "OutPatient" &&
              props.data.visit.internalStatus !==
                PATIENT_VISIT_INTERNAL_STATUS.NOT_IN_SITE)) &&
            (helperServices.CheckAccessLevel("patients") ||
              helperServices.CheckAccessLevel("InsurancePatients")) && (
              <i
                className="material-icons cpointer actionbutton"
                title="Billable"
                onClick={(event) => moveToBill(props.data, event)}
              >
                currency_rupee
              </i>
            )}

          {props.data.visit.type === "InPatient" &&
            !isWalkinVisit &&
            props.data.visit.status !== "close" &&
            props.data.visit.internalStatus !== "notInSite" &&
            (helperServices.CheckAccessLevel("InsurancePatients") ||
              helperServices.CheckAccessLevel("patients")) && (
              <i
                className="material-icons cpointer"
                title="Discharge Summary"
                style={{ color: "#202191ff" }}
                onClick={(event) => dischargeSummaryClick(props.data, event)}
              >
                exit_to_app
              </i>
            )}

          {(props.data.visit.status !== "close" ||
            props.data.visit.internalStatus === "notInSite") &&
            helperServices.CheckAccessLevel("patients") && (
              <i
                className="material-icons cpointer"
                title="Close patient"
                onClick={(event) => patientCloseClick(props.data, event)}
                style={{ color: "#a32424" }}
              >
                close
              </i>
            )}
        </>
      )}

      {adminPageHeader === DASHBOARD && (
        <>
          {props.colDef.field === "productId" && (
            <div style={{ position: "relative", width: "100%" }}>
              <input
                className="p-2 ag-grid-input border-0"
                type="text"
                value={search || ""}
                placeholder="Search Product"
                autoComplete="off"
                onChange={(e) => getProducts(e.target.value, props.data)}
                style={{ height: "27px", width: "100%" }}
              />
              {displayProducts?.length > 0 && (
                <div className="mt-2 shadow product-list-container position-absolute w-100 bg-white">
                  {displayProducts.map((product) => (
                    <div
                      key={product.productId}
                      className="border-bottom p-2 cpointer"
                      onClick={() => productSelected(product)}
                    >
                      {product.productName}{" "}
                      <span className="text-muted">({product.productId})</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {props.colDef.field === "Actions" && (
            <Button
              sx={{ textTransform: "none", minWidth: "60px" }}
              variant="contained"
              size="small"
              onClick={(event) => updateProductId(event, props.data)}
            >
              Save
            </Button>
          )}
        </>
      )}

      {/* Other page headers (ServiceMaster, Forms, etc.) */}
      {window.location.href.split("/")[3] === "ServiceMaster" && (
        <i
          className="material-icons cpointer"
          title="Delete Service"
          onClick={(event) => tpaDeleteClick(props.data, event)}
        >
          delete
        </i>
      )}

      {window.location.href.split("/")[3] === "Forms" && (
        <>
          <i
            className="material-icons cpointer"
            title="Edit form"
            onClick={() => handleFormEditClick(props.data.basicinfo.id)}
          >
            edit
          </i>
          <i className="material-icons cpointer" title="Delete form">
            delete
          </i>
        </>
      )}

      {[
        "insurance",
        "tpa",
        "staff",
        "doctor",
        "labList",
        "packageService",
      ].includes(adminPageHeader) && (
        <i className="material-icons cpointer" title="Delete">
          delete
        </i>
      )}

      {adminPageHeader === "roomList" && props.data && (
        <>
          {props.data.status === "active" ? (
            <i className="material-icons text-success" title="Active">
              check
            </i>
          ) : (
            <i className="material-icons text-danger" title="Inactive">
              close
            </i>
          )}
        </>
      )}
    </div>
  );
}

/* function mapStateToProps(state) {
  console.log("State in cell render", state,this.props);
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return {
  };
}

const BtnCellRendererWithProps = connect(mapStateToProps, mapDispatchToProps)(BtnCellRenderer);

const BtnCellRendererWithRouter = withRouter(BtnCellRendererWithProps);
export default BtnCellRendererWithRouter; */
// const adminPageHeader = useSelector(state => state.patientDetailsState.pageheader)

export default BtnCellRenderer;
